const backUrl = process.env.REACT_APP_BACKEND_URL;

export default backUrl;